module.exports = __webpack_public_path__ + "static/media/project_rock_front.9a56af42.jpeg";